<template>
  <div class="nav_box" :style="{'height':!noshadow?'50px': '46px'}">
    <div class="flex nav space_between" :class="{'shadow': !noshadow}" :style="{'background': bgc}">
      <van-icon name="arrow-left" :color="font_c" size="18px" @click="onClickLeft" v-if="!hideLeft"/>
      <span class="tit" :style="{'color': font_c,'font-size': '14px'}">{{title}}</span>
      <van-search class="search" placeholder="请输入搜索关键词" v-model="value" :background="bgc" shape="round" readonly @click="onClickRight"/>
    </div>
<!--    <van-nav-bar-->
<!--      class="nav"-->
<!--      :class="{'shadow': !noshadow}"-->
<!--      :z-index="99"-->
<!--      @click-left="onClickLeft"-->
<!--      @click-right="onClickRight"-->
<!--      :style="{'background-color': bgc}"-->
<!--      :border="isborder"-->
<!--    >-->
<!--      <div slot="left" :style="{'color': font_c}"><van-icon name="arrow-left" :color="font_c"  size=".5rem"/>{{leftText}}</div>-->
<!--      <div slot="title" :style="{'color': font_c}">{{title}}</div>-->
<!--      <div slot="right" v-if="rightText" :style="{'color': font_c}">{{rightText}}</div>-->
<!--      <van-icon v-if="rightName" :name="rightName" slot="right" size="30px" :color="font_c"/>-->
<!--    </van-nav-bar>-->
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    leftText: String,
    rightText: String,
    bgc: String,
    noshadow: Boolean,
    hideLeft: Boolean,
    rightName: String,
    font_c: {
      type: String,
      default () {
        return '#333333'
      }
    },
    isborder: Boolean,
    tj: String,
    active: Number
  },
  data () {
    return {
      value: ''
    }
  },
  watch: {
    '$route' (val) {
      console.log(val)
    }
  },
  created () {
    console.log(2)
  },
  methods: {
    onClickLeft () {
      history.go(-1)
    },
    onClickRight () {
      let temp = new Date().getTime()
      this.$router.push({path: '/SearchList', query: {active: this.active, from: 'single', tj: this.tj ? this.tj : '', temp: temp}})
    }
  }
}
</script>

<style scoped>
  .nav_box{
    height: 46px;/*no*/
  }
  .nav{
    position: fixed;
    top:0;
    left: 0;
    z-index: 99;
    width: 100%;
    padding: 0 8px; /*no*/
  }
  .shadow{
    box-shadow: 0 0 4px rgba(99,99,99,.3);/*no*/
  }
  .tit{
    display: inline-block;
    width: 3rem;
  }
  .search{
    width: 100%;
  }
  /deep/ .van-search{
    padding: 8px 12px; /*no*/
  }
  .van-search /deep/ .van-cell {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    padding: 3px 8px 3px 0; /*no*/
  }
</style>



// WEBPACK FOOTER //
// src/components/searchNav.vue